export default from './promote-moderator-modal';



// WEBPACK FOOTER //
// ./app/containers/promote-moderator-modal/index.js